<template>
  <el-container style="height: 100%">
    <el-header>
      <ui-header/>
    </el-header>
    <el-main style="padding: 0; overflow: hidden;">
      <el-container style="height: 100%;">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
import uiHeader from "./UiHeader.vue";
import userService from '../components/service/UserService'

export default {
  name: "index",
  components: {
    uiHeader
  },
}
</script>
<style>
body{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
/* 标题栏卡片 — 匹配 Login 卡片风格 */
.page-header {
  background: #FFFFFF;
  margin-bottom: 16px;
  padding: 16px 20px;
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: box-shadow 0.3s ease;
}
.page-header:hover {
  box-shadow: 0 2px 14px rgba(64, 158, 255, 0.06), 0 8px 32px rgba(0, 0, 0, 0.07);
}

.page-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 6px;
}

.page-header-btn {
  text-align: right;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
<style scoped>
.fade-enter {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s ease;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue